import { PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

interface Props extends PropsWithChildren {
  isOpened?: boolean;
}

const Modal = ({ children, isOpened }: Props) => {
  const modalArea = document.getElementById('modal');
  return createPortal(
    <>
      {isOpened && (
        <div className="fixed left-0 top-0 z-30 flex h-screen w-full items-center justify-center bg-black/10 p-4">
          {children}
        </div>
      )}
    </>,
    modalArea as HTMLElement
  );
};

export default Modal;
